import { axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { CustomAxiosResponse } from '@/api/AxiosResponse';
import { AddressListType, ResAddressListType } from '@/types/addresses/read-types';

// 지갑 주소, 코드, 활성화 리스트
export const readAddressList = async (
  addressListType: AddressListType,
): Promise<CustomAxiosResponse<ResAddressListType[]>> => {
  const payload = {
    path: '/admins/list',
    body: { ...addressListType },
  };
  return sendRequest(payload, 'readAddressList', axiosPost);
};
